import dayjs from 'dayjs';
import React, { createContext, ReactNode, useMemo, useState } from 'react';

export interface NomineesPeriodContextValue {
  startOperationDate: string | null;
  endOperationDate: string | null;
  setStartOperationDate: (value: string | null) => void;
  setEndOperationDate: (value: string | null) => void;
}

const defaultPeriod = {
  start: dayjs().startOf('month').toISOString(),
  end: dayjs().endOf('month').toISOString(),
};

export const NomineesPeriodContext =
  createContext<NomineesPeriodContextValue | null>(null);

interface NomineesPeriodProviderProps {
  children: ReactNode;
}

export const NomineesPeriodProvider: React.FC<NomineesPeriodProviderProps> = ({
  children,
}) => {
  const [startOperationDate, setStartOperationDate] = useState<string | null>(
    defaultPeriod.start,
  );
  const [endOperationDate, setEndOperationDate] = useState<string | null>(
    defaultPeriod.end,
  );

  const value = useMemo<NomineesPeriodContextValue>(
    () => ({
      startOperationDate,
      endOperationDate,
      setStartOperationDate,
      setEndOperationDate,
    }),
    [startOperationDate, endOperationDate],
  );

  return (
    <NomineesPeriodContext.Provider value={value}>
      {children}
    </NomineesPeriodContext.Provider>
  );
};

export const useNomineesPeriod = (): NomineesPeriodContextValue => {
  const context = React.useContext(NomineesPeriodContext);
  if (!context) {
    throw new Error(
      'useNomineesPeriod must be used within a NomineesPeriodProvider',
    );
  }
  return context;
};
